import { uncoveredSalesChannelWarningSchema } from "@redotech/redo-model/sales-channels";
import * as z from "zod";

export const getUncoveredSalesChannelWarnings = {
  name: "getUncoveredSalesChannelWarnings" as const,
  input: z.object({}),
  output: z.object({ warnings: z.array(uncoveredSalesChannelWarningSchema) }),
};

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { uncoveredSalesChannelWarningSchema } from "@redotech/redo-model/sales-channels";
